import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let catalogCache = null;
let catalogPromise = null;

export function useCatalog() {
  const [catalog, setCatalog] = useState(catalogCache);
  useEffect(() => {
    if (catalogCache) return;
    catalogPromise = catalogPromise || api.get("/properties/catalog").then((r) => (catalogCache = r.data));
    catalogPromise.then(setCatalog).catch(() => { catalogPromise = null; });
  }, []);
  return catalog;
}

const locCache = new Map();

export function useLocations(parentId, enabled = true) {
  const key = parentId || "__root";
  const [items, setItems] = useState(locCache.get(key) || []);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!enabled) { setItems([]); return; }
    if (locCache.has(key)) { setItems(locCache.get(key)); return; }
    let live = true;
    setLoading(true);
    api.get("/locations", { params: parentId ? { parent_id: parentId } : {} })
      .then((r) => { locCache.set(key, r.data); if (live) setItems(r.data); })
      .finally(() => live && setLoading(false));
    return () => { live = false; };
  }, [key, parentId, enabled]);
  return { items, loading };
}

export const clearLocationCache = () => locCache.clear();
